import React from 'react';
import { IconProps } from '.';

const SvgManagementFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M11.5 2.133a1 1 0 0 1 1 0l7.794 4.5a1 1 0 0 1 .5.866v7.846a3 3 0 0 1-1.5 2.598L13.5 21.288a3 3 0 0 1-3 0l-5.794-3.345a3 3 0 0 1-1.5-2.598V7.499a1 1 0 0 1 .5-.866l7.794-4.5ZM12 6a1 1 0 0 1 1 1v4.423l3.83 2.211a1 1 0 1 1-1 1.732L12 13.155l-3.83 2.21a1 1 0 1 1-1-1.731L11 11.422V7a1 1 0 0 1 1-1Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgManagementFill;
